<template>
  <section class="placeholder-page">
    <div class="placeholder-hero">
      <div>
        <span class="placeholder-eyebrow">{{ route.meta?.eyebrow }}</span>
        <h1>{{ route.meta?.title }}</h1>
        <p>{{ route.meta?.description }}</p>
      </div>

      <div class="placeholder-badge">
        {{ route.meta?.badge || "Planejado" }}
      </div>
    </div>

    <div class="placeholder-grid">
      <article
        v-for="item in roadmap"
        :key="item.title"
        class="placeholder-card"
      >
        <span>{{ item.stage }}</span>
        <strong>{{ item.title }}</strong>
        <p>{{ item.description }}</p>
      </article>
    </div>

    <div class="placeholder-panel">
      <div>
        <span>Preparação</span>
        <strong>Estrutura reservada para expansão</strong>
        <p>
          Esta página já faz parte da navegação principal do Certificador. A
          funcionalidade será ativada conforme avançarmos nas próximas fases.
        </p>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();

const roadmap = computed(() => {
  return (
    route.meta?.roadmap || [
      {
        stage: "01",
        title: "Mapeamento",
        description: "Definir requisitos, fluxos e permissões do módulo.",
      },
      {
        stage: "02",
        title: "Integração",
        description: "Conectar o módulo ao backend e aos serviços existentes.",
      },
      {
        stage: "03",
        title: "Produção",
        description: "Validar o fluxo completo antes de liberar para uso real.",
      },
    ]
  );
});
</script>

<style scoped>
.placeholder-page {
  max-width: 1180px;
  margin: 0 auto;
}

.placeholder-hero {
  display: flex;
  justify-content: space-between;
  gap: 1.5rem;
  padding: 1.65rem 1.85rem;
  border-radius: 28px;
  background: radial-gradient(
      circle at top right,
      rgba(255, 148, 23, 0.22),
      transparent 20rem
    ),
    rgba(255, 255, 255, 0.86);
  border: 1px solid rgba(148, 163, 184, 0.22);
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.1);
}

.placeholder-eyebrow,
.placeholder-card span,
.placeholder-panel span {
  color: #f97316;
  font-family: "XoloniumBold", sans-serif;
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.12em;
}

.placeholder-hero h1 {
  margin: 0.45rem 0;
  color: #0f172a;
  font-size: clamp(1.85rem, 3.2vw, 2.75rem);
  line-height: 0.98;
  letter-spacing: -0.045em;
  font-family: "XoloniumBold", sans-serif;
}

.placeholder-hero p,
.placeholder-card p,
.placeholder-panel p {
  max-width: 760px;
  color: #64748b;
  line-height: 1.75;
}

.placeholder-badge {
  align-self: flex-start;
  padding: 0.62rem 0.9rem;
  font-size: 0.8rem;
  border-radius: 999px;
  color: #111827;
  background: linear-gradient(135deg, #ffb020, #ff7300);
  font-family: "XoloniumBold", sans-serif;
  box-shadow: 0 14px 32px rgba(255, 115, 0, 0.22);
}

.placeholder-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1rem;
  margin-top: 1.2rem;
}

.placeholder-card,
.placeholder-panel {
  padding: 1.15rem;
  border-radius: 22px;
  background: rgba(255, 255, 255, 0.84);
  border: 1px solid rgba(148, 163, 184, 0.22);
  box-shadow: 0 18px 44px rgba(15, 23, 42, 0.08);
}

.placeholder-card strong,
.placeholder-panel strong {
  display: block;
  margin-top: 0.55rem;
  color: #0f172a;
  font-size: 1.05rem;
  font-family: "XoloniumBold", sans-serif;
}

.placeholder-panel {
  margin-top: 1.2rem;
  background: radial-gradient(
      circle at top left,
      rgba(15, 23, 42, 0.08),
      transparent 22rem
    ),
    rgba(255, 255, 255, 0.84);
}

@media (max-width: 900px) {
  .placeholder-hero {
    flex-direction: column;
    padding: 1.4rem;
  }

  .placeholder-grid {
    grid-template-columns: 1fr;
  }
}
</style>
